import { Button } from 'primereact/button';
import { useState, useEffect, useRef } from 'react';
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import CommonConfig from '../../../utils/constant';
import Toast from '../../Shared/Toast/Toast';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import { Checkbox } from 'primereact/checkbox';
import { useCatchResponse } from '../../../utils/useCatchResponse';
import { Calendar } from 'primereact/calendar';
import moment from 'moment';


const AddEditManageStudentPhoto = (props) => {
    const { catchResponse } = useCatchResponse();
    const [securityUserID, setSecurityUserID] = useState("");
    const [classList, setClassList] = useState('');
    const [className, setClassName] = useState([]);
    const [classNameErrText, setClassNameErrText] = useState('');
    const [classNameErr, setClassNameErr] = useState(false);
    const [authorityList, setAuthorityList] = useState([]);
    const [authority, setAuthority] = useState('');
    const [editMode, setEditMode] = useState('PhotoOnly');
    const [isClassTeacher, setIsClassTeacher] = useState(false);
    const editModeOptions = [
        { label: 'Photo Only', value: 'PhotoOnly' },
        { label: 'Full Profile', value: 'FullProfile' },
    ];
    const [fromDate, setFromDate] = useState('');
    const [fromDateErr, setFromDateErr] = useState(false);
    const [fromDateErrText, setFromDateErrText] = useState('');
    const [toDate, setToDate] = useState('');
    const [toDateErr, setToDateErr] = useState(false);
    const [toDateErrText, setToDateErrText] = useState(false);
    const submitButtonRef = useRef(null);
    const classNameRef = useRef(null);
    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        setTimeout(() => {
            classNameRef.current?.focus();
        }, 100);
    }, []);


    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        getFinancialYearData(loginData);
        GetTeachersList(loginData?._id, loginData?.Name);

        if (props?.EditData) {
            setClassName(props?.EditData?.ClassName ? props?.EditData?.ClassName.split(',') : []);
            setFromDate(props?.EditData?.StartDate ? new Date(props?.EditData?.StartDate) : null);
            setToDate(props?.EditData?.EndDate ? new Date(props?.EditData?.EndDate) : null);
            setAuthority(props?.EditData?.Authority);
            setEditMode(props?.EditData?.EditMode || 'PhotoOnly');
            setIsClassTeacher(!!props?.EditData?.IsClassTeacher);
        }
    }, []);

    const getFinancialYearData = async (userData) => {
        const years = await CommonConfig.getFinancialYears(userData?.CreatedBy || userData?._id);
        const currentYear = CommonConfig.getCurrentFinancialYear(years);
        const selectedaYear = CommonConfig.getCookie('selectedAcademicYear');
        await GetClassList(CommonConfig.isOrgOwner(userData?.UserRole) ? userData?._id : (userData?.CreatedBy || userData?._id), selectedaYear ?? currentYear?.value);
    }

    const GetTeachersList = async (id, userName) => {
        try {
            const data = { UserID: id };
            await api.post(APIConstant.path.getUser, data).then(async response => {
                if (response.success) {
                    const dataList = response.data
                        .filter((x) => x.UserType === 'Teacher' && x?.Status === 'Active')
                        .map((y) => ({
                            label: userName,
                            value: id
                        }, {
                            ...y,
                            label: y.Name,
                            value: y._id
                        }));
                    setAuthorityList(dataList);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    };

    const onCancel = () => {
        props.onCancel();
        setClassName([]);
        setAuthority('');
        setEditMode('PhotoOnly');
        setIsClassTeacher(false);
        setFromDate('');
        setFromDateErr(false);
        setFromDateErrText('');
        setToDate('');
        setToDateErr(false);
        setToDateErrText('');
    }

    const validate = () => {
        let formIsValid = true;
        if (CommonConfig.isEmpty(className)) {
            formIsValid = false;
            setClassNameErr(true);
            setClassNameErrText("ClassName is required");
        } else {
            setClassNameErr(false);
            setClassNameErrText("");
        }
        return formIsValid;
    };

    const GetClassList = async (id, academicYearId) => {
        try {
            let data = {
                UserID: id,
                FinancialYearId: academicYearId
            }
            await api.post(APIConstant.path.getClassList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setClassList(res?.data?.filter(x => x?.Status === 'Active')?.map((x) => ({
                        ...x,
                        value: x?._id,
                        label: `${x?.ClassName}-${x?.SectionFullName}-${x?.MediumName}-${x?.Board}`
                    })));

                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const AddUpdateConfigData = async (e) => {
        if (validate(e)) {
            try {
                let data = {
                    id: props?.EditData?._id,
                    Authority: isClassTeacher ? '' : authority,
                    IsClassTeacher: isClassTeacher,
                    EditMode: editMode || 'PhotoOnly',
                    ClassName: className.length > 1 ? className.join(',') : className[0],
                    StartDate: moment(fromDate).format('YYYY-MM-DD'),
                    EndDate: moment(toDate).format('YYYY-MM-DD'),
                    CreatedBy: securityUserID
                };

                Loader.show();
                await api.post(APIConstant.path.AddUpdateManageStudentPhotos, data).then(async response => {
                    let res = response;
                    if (res.success) {
                        Toast.success({ message: res.message });
                        Loader.hide();
                        onCancel();
                    } else {
                        Toast.error({ message: res.message });
                        Loader.hide();
                    }
                })
                    .catch((err) => {
                        Toast.error({ message: err });
                        Loader.hide();
                    });
            } catch (err) {
                console.log(err);
                Loader.hide();
                onCancel();
                catchResponse(err);
            }
        }
    };

    const handleFromChange = (value) => {
        const endDate = toDate;
        const startDate = value;
        if (endDate && startDate > endDate) {
            setFromDateErr(true);
            setFromDateErrText("'From' time cannot be later than 'To' date.");
        } else if (endDate && startDate.getDate() === endDate.getDate()) {
            setFromDateErr(true);
            setFromDateErrText("'From' date cannot be the same as 'To' date.");
        } else {
            setFromDateErr(false);
            setFromDateErrText("");
        }
        setFromDate(value);
    };

    const handleToChange = (value) => {
        const startDate = fromDate;
        const endDate = value;
        if (startDate && endDate < startDate) {
            setToDateErr(true);
            setToDateErrText("'To' time cannot be earlier than 'From' date.");
        } else if (startDate && startDate.getDate() === endDate.getDate()) {
            setToDateErr(true);
            setToDateErrText("'To' date cannot be the same as 'From' date.");
        } else {
            setToDateErr(false);
            setToDateErrText("");
        }
        setToDate(value);
    };

    return (
        <div className="p-d-flex p-flex-column p-jc-between">
            <div style={{ maxHeight: 'calc(100vh - 260px)', overflow: 'auto' }}>
                <div className='p-grid p-mt-2'>
                    <div className="p-col-12 p-md-6 p-pt-2">
                        <div className="custom-inputs">
                            <label htmlFor="selectedClassName" className="mr-2">Class<span style={{ color: "red" }}>*</span>
                            </label>
                            <div className="custom-inputs">
                                <MultiSelect ref={classNameRef} id="selectedClassName" className='p-w-100 p-mt-1' value={className} options={classList}
                                    onChange={(e) => setClassName(e.value)} placeholder="Select Class" display="chip" filter
                                    showClear />
                                <span className="error-msg" style={{ color: 'red' }}>
                                    {classNameErr ? classNameErrText : null}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="p-col-12 p-md-6 p-pt-2">
                        <div className="custom-inputs p-d-flex p-ai-center" style={{ marginTop: '1.6rem' }}>
                            <Checkbox inputId="isClassTeacher" checked={isClassTeacher} onChange={(e) => {
                                setIsClassTeacher(e.checked);
                                if (e.checked) setAuthority('');
                            }} />
                            <label htmlFor="isClassTeacher" className="p-ml-2" style={{ marginLeft: '0.5rem', cursor: 'pointer' }}>Class Teacher</label>
                        </div>
                    </div>
                    {!isClassTeacher && (
                        <div className="p-col-12 p-md-6 p-pt-2">
                            <div className="custom-inputs">
                                <label htmlFor="authority" className="mr-2">Authority</label>
                                <div className="custom-inputs">
                                    <Dropdown id="authority" className='p-w-100 p-mt-1' value={authority} options={authorityList} onChange={(e) => setAuthority(e.value)} placeholder="Select Authority" display="chip" filter
                                        showClear />
                                </div>
                            </div>
                        </div>
                    )}
                    <div className="p-col-12 p-md-6 p-pt-2">
                        <div className="custom-inputs">
                            <label htmlFor="editMode" className="mr-2">Edit Mode</label>
                            <div className="custom-inputs">
                                <Dropdown id="editMode" className='p-w-100 p-mt-1' value={editMode} options={editModeOptions} onChange={(e) => setEditMode(e.value)} placeholder="Select Edit Mode" />
                            </div>
                        </div>
                    </div>
                    <div className="p-col-12 p-md-6 p-pt-2">
                        <div className="custom-inputs">
                            <label htmlFor="clasName">From Date </label>
                            <Calendar className='p-w-100 p-mt-1' value={fromDate} onChange={(e) => handleFromChange(e.value)} dateFormat='dd/mm/yy' />
                            <span className="error-msg" style={{ color: 'red' }}>
                                {fromDateErr ? fromDateErrText : null}
                            </span>
                        </div>
                    </div>
                    <div className="p-col-12 p-md-6 p-pt-2">
                        <div className="custom-inputs">
                            <label htmlFor="clasName">To Date </label>
                            <Calendar className='p-w-100 p-mt-1' value={toDate} onChange={(e) => handleToChange(e.value)} dateFormat='dd/mm/yy' onKeyDown={(e) => {
                                if (e.key === 'Tab' && !e.shiftKey) {
                                    e.preventDefault();
                                    if (submitButtonRef.current) {
                                        submitButtonRef.current.focus();
                                    }
                                }
                            }} />
                            <span className="error-msg" style={{ color: 'red' }}>
                                {toDateErr ? toDateErrText : null}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div className='dialog-footer p-d-flex p-ai-center p-jc-end p-pb-5'>
                <Button className='p-m-0 btn-text-action-secondary p-m-1' onClick={() => onCancel()}>Cancel</Button>
                <Button ref={submitButtonRef} className='p-m-0 btn-text-action-primary p-m-1 color-white submit-focus' label="Save" severity="secondary" raised onClick={() => AddUpdateConfigData()} />
            </div>
        </div>
    );
};

export default AddEditManageStudentPhoto;
